import 'globalthis/auto';
import 'react-app-polyfill/stable';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { AnalysisPage } from './pages/Analysis';
import { VotingPage } from './pages/Voting';
import { LaunchPage } from './pages/Launch';
import { useStore } from './store';
import { getLibrary } from './lib/web3-react-bsc';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Web3ReactProvider } from '@web3-react/core';
import { Bsc } from './pages/Home/bsc';
import { Polygon } from './pages/Home/polygon';

import { Iotex } from './pages/Home/iotex';
import { BscPage } from './pages/Bsc';
import { IotexPage } from './pages/Iotex';

import { Leva, useControls } from 'leva';
import { Eth } from './pages/Home/eth';
import { Modal } from './components/Modal';
import { Toaster } from 'react-hot-toast';

if (process.env.NODE_ENV == 'production') {
  Sentry.init({
    dsn: 'https://3731f73d7eaf4e008d0409f867665f99@o563381.ingest.sentry.io/5703305',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0
  });
}
const App = () => {
  const { lang, base, dev } = useStore();
  const setting = useControls({ devUI: dev.devUI, devPool: dev.devPool });
  useEffect(() => {
    lang.init();
    base.init();
  }, []);
  useEffect(() => {
    Object.assign(dev, setting);
  }, [setting]);

  return (
    <React.StrictMode>
      <Leva hidden={!dev.dev} />
      <Modal />
      <Toaster />
      <Router>
        <Switch>
          <Route exact path="/" component={LaunchPage} />
          <Route exact path="/bsc">
            <Web3ReactProvider getLibrary={getLibrary}>
              <Bsc />
            </Web3ReactProvider>
          </Route>
          <Route exact path="/polygon">
            <Web3ReactProvider getLibrary={getLibrary}>
              <Polygon />
            </Web3ReactProvider>
          </Route>
          <Route exact path="/eth">
            <Web3ReactProvider getLibrary={getLibrary}>
              <Eth />
            </Web3ReactProvider>
          </Route>
          <Route exact path="/iotx">
            <Web3ReactProvider getLibrary={getLibrary}>
              <Iotex />
            </Web3ReactProvider>
          </Route>
          <Route exact path="/iotx-v1" component={IotexPage} />
          <Route exact path="/bsc-v1" component={BscPage} />
          <Route exact path="/analytics" component={AnalysisPage} />
          <Route exact path="/voting" component={VotingPage} />
        </Switch>
      </Router>
    </React.StrictMode>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
